import * as Yup from "yup";

export const email = Yup.string()
    .email("Please enter a valid email.")
    .required("Please enter an email.");

export const password = Yup.string().required("Please enter a password.");

export const confirmPassword = Yup.string()
    .required("Please confirm your password.")
    .oneOf([Yup.ref("password"), null], "Check your passwords match.");

export const rememberMe = Yup.boolean();

export const name = Yup.string().required("Please enter your name.");
